define 'controller/SortingController', ['jquery', 'lib/kryptonite'], ($) ->
  class SortingController
    constructor: (@$el) ->
      @_sortSelect()
      @_closeMobileLayer()

    _closeMobileLayer: ->
      $('.sorting__layer-header').on 'click', ->
        $('.dropdown__content').removeClass('dropdown__content--visible')
        $('.dropdown__icon').removeClass('dropdown__icon--opened')

    _sortingListOrder: ->
      active = $('.category__header__sorting-list__entries span.active').closest('label')
      first = $('.category__header__sorting-list__entries label')[0]
      active.each ->
        $(first).before this
        return
      return

    _sortSelect: ->
      self = @
      @$el.on 'click', '.sorting__item', (e) ->
        url = $(@).data 'url'
        self._send(url)

    _send: (url) ->
      self = @
      # reload for older browsers
      unless history.pushState?
        window.location = url
        return

      history.pushState(null, null, url)
      $('body').addClass('loading')
      $.kryptonite
        url: url
        type: 'POST'
        complete: (response) ->
          $('body').removeClass('loading')
          self._sortSelect()


    destroy: ->
      @$el.off()
